import React from 'react';
import { PNGS, SVGS } from '../../../assets';
import './waba-generate-link.scss';
import ZoButton from '@zonofi/zo-components/input/zo-button/zo-button';

interface WabaGenerateLinkProps {
  onBackClick: () => void;
  onContinueClick: () => void;
  onSkipClick: () => void;
}

export const WabaGenerateLink: React.FC<WabaGenerateLinkProps> = ({
  onBackClick,
  onSkipClick,
  onContinueClick,
}) => {
  return (
    <div className="waba-generate-link">
      <div className="waba-generate-link-container">
        <div className="waba-generate-link-container-header">
          <div
            onClick={onBackClick}
            className="waba-generate-link-container-header-back-icon primary-font-regular"
          >
            <SVGS.ArrowLeftComponent onClick={onBackClick} fill="#000000" />{' '}
            Back
          </div>
        </div>
        <div className="waba-generate-link-container-body">
          <img
            src={SVGS.FacebookIcon}
            alt=""
            className="waba-generate-link-container-header-icon"
            width={93}
          />
          <div className="waba-generate-link-container-header-text">
            <span className="waba-generate-link-container-header-text-heading primary-font-bold">
              WABA signup is not supported in mobile browser.
            </span>
            <span className="waba-generate-link-container-header-text-description primary-font-regular">
              This action can’t be completed in a mobile browser as per Facebook
              Guidelines, Please copy the link and open it on a desktop browser
              to continue
            </span>
          </div>
          <div className="waba-generate-link-container-header-button">
            <ZoButton
              label="Generate Signup Link"
              onClick={onContinueClick}
              variant="primary"
              size="medium"
              startIcon={
                <img src={SVGS.Link_URL} alt="" width={20} height={20} />
              }
              style={{
                border: 'none',
              }}
            />
            <ZoButton
              variant="secondary"
              isLoading={false}
              onClick={onSkipClick}
              label={'I’ll do it Later'}
              style={{ border: '1px solid #32A7E8' }}
              className=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};
